import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";

export default function Revue() {
  const { t, i18n } = useTranslation();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data)).catch(() => setArticles([])).finally(() => setLoading(false));
  }, []);

  const fmtDate = (iso) => new Date(iso).toLocaleDateString(i18n.language, { day: "2-digit", month: "short", year: "numeric" });

  return (
    <div data-testid="revue-page" className="pt-32 md:pt-40 pb-24">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="overline mb-5">{t("revue.overline")}</div>
        <h1 className="font-serif text-5xl md:text-8xl text-[#F5F5F0] leading-[0.9] mb-10">
          {t("revue.title_1")} <br />
          <em className="text-[#D4AF37] not-italic">{t("revue.title_2")}</em>
        </h1>
        <p className="text-[#A3A39D] max-w-2xl mb-20 leading-relaxed">{t("revue.lede")}</p>

        {loading ? (
          <div className="text-[#A3A39D] text-sm">{t("catalog.loading")}</div>
        ) : articles.length === 0 ? (
          <div className="text-[#A3A39D] text-sm">{t("catalog.empty")}</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-14">
            {articles.map((a, i) => (
              <Link
                key={a.id}
                to={`/revue/${a.slug}`}
                data-testid={`article-card-${a.slug}`}
                className="group block fade-up"
                style={{ animationDelay: `${i * 70}ms` }}
              >
                <div className="img-hover aspect-[4/3] bg-[#151516] mb-5">
                  <img src={a.cover_image} alt={a.title} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="flex items-center gap-3 mb-3">
                  <div className="overline text-[10px]">{a.category}</div>
                  <span className="text-[10px] text-[#A3A39D] tracking-widest">{fmtDate(a.created_at)}</span>
                </div>
                <h3 className="font-serif text-2xl text-[#F5F5F0] leading-tight mb-3 group-hover:text-[#D4AF37] transition-colors">
                  {a.title}
                </h3>
                <p className="text-sm text-[#A3A39D] leading-relaxed mb-4">{a.excerpt}</p>
                <div className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] inline-flex items-center gap-2">
                  {t("revue.read_more")} <ArrowUpRight size={14} strokeWidth={1.25} />
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
